import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import { Table } from 'react-bootstrap';
import { IProductCompensation, IProductType } from './Entities';
import AgreementsFormListRow from './AgreementsFormListRow';

interface IAgreementsFormListProps {
    productCompensations: IProductCompensation[];
    productTypes: IProductType[];
    delete: (id: number, product: number) => void;
}

const AgreementsFormList = (props: IAgreementsFormListProps) => {
    return (
        <Table hover responsive>
            <thead>
                <tr>
                    <th>{Translate('agreements/modal/list/table-header/product')}</th>
                    <th className="num">{Translate('agreements/modal/list/table-header/price')}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.productCompensations &&
                    props.productCompensations.map(
                        (productCompensation: IProductCompensation, index: number) => {
                            return (
                                <AgreementsFormListRow
                                    key={index}
                                    productTypes={props.productTypes}
                                    productCompensation={productCompensation}
                                    delete={props.delete}
                                />
                            );
                        }
                    )}
            </tbody>
        </Table>
    );
};

export default AgreementsFormList;
